import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';
import { Device } from '../interface/devices-interface.i';

@Injectable({
  providedIn: 'root'
})
export class DeviceStoreService {
  $deviceStoreData: Observable<Device>;
  private _deviceStoreData: Device;// keep something related to device
  private deviceStoreDataSubject = new BehaviorSubject<Device>(undefined);

  constructor() {
    this.initParams();
  }

  //comment about function
  updateDeviceData(value: Device) {
    const existingData = this.formatSettings(this._deviceStoreData);
    const newData =this.formatSettings(value);
    let settingsData;
    if(existingData?.settings&& newData?.settings){
      settingsData=this.mergeDeep(existingData?.settings,newData?.settings);
    } 
    const updatedDevice = { ...existingData, ...newData };
    
    if(settingsData){
      updatedDevice.settings = settingsData;
    }
    if(typeof updatedDevice?.settings === 'object'){
      updatedDevice.settings = JSON.stringify(updatedDevice.settings);
    }
    this._deviceStoreData = updatedDevice;
  }

  //comment about function
  clearStoreData() {
    this._deviceStoreData = undefined;
  }

  private initParams() {
    this.$deviceStoreData = this.deviceStoreDataSubject.asObservable();
  }

  get deviceStoreData(): Device {
    return this._deviceStoreData; 
  }

  set deviceStoreData(value: Device) { 
    this._deviceStoreData = value;
    this.deviceStoreDataSubject.next(this._deviceStoreData);
  }
  //Below changes are for IIT2-16238
  formatSettings(inputData){
    let tempData = inputData;
    if(typeof tempData?.settings === "string"){
      tempData.settings = JSON.parse(tempData?.settings);
    }
    return tempData;
  }
  isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
  }
   mergeDeep(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
  
    if (this.isObject(target) && this.isObject(source)) {
      for (const key in source) {
        if (this.isObject(source[key])) {
          if (!target[key]) Object.assign(target, { [key]: {} });
          this.mergeDeep(target[key], source[key]);
        } else {
          Object.assign(target, { [key]: source[key] });
        }
      }
    }
  
    return this.mergeDeep(target, ...sources);
  }
}
